export const FORGOT_ACTIONS = {
	PREV_STEP: 'PREV_STEP',
	NEXT_STEP: 'NEXT_STEP',
	SET_STEP: 'SET_STEP',
	LOGIN: 'LOGIN',
	RESET: 'RESET',
	SUCCESS: 'SUCCESS',
};
